(() => {
  class KozbinoMegaMenuController {
    constructor(menu) {
      this.menu = menu;
      this.summary = menu.querySelector(':scope > summary');
      this.observer = new MutationObserver(this.handleAttributeChange.bind(this));
      this.handlePointerEnter = this.handlePointerEnter.bind(this);
      this.handleFocusIn = this.handleFocusIn.bind(this);
      this.handleClick = this.handleClick.bind(this);

      this.observer.observe(this.menu, { attributes: true, attributeFilter: ['open'] });
      this.menu.addEventListener('mouseenter', this.handlePointerEnter);
      this.menu.addEventListener('focusin', this.handleFocusIn);
      this.menu.addEventListener('click', this.handleClick);
      this.syncAria();
    }

    handleAttributeChange() {
      if (this.menu.hasAttribute('open')) {
        this.closeOtherMegaMenus();
      }
      this.syncAria();
    }

    handlePointerEnter() {
      window.setTimeout(() => {
        if (this.menu.hasAttribute('open')) {
          this.closeOtherMegaMenus();
        }
      }, 120);
    }

    handleFocusIn() {
      window.requestAnimationFrame(() => {
        if (this.menu.hasAttribute('open')) {
          this.closeOtherMegaMenus();
        }
      });
    }

    handleClick() {
      window.requestAnimationFrame(() => {
        if (this.menu.hasAttribute('open')) {
          this.closeOtherMegaMenus();
        }
      });
    }

    closeOtherMegaMenus() {
      document.querySelectorAll('details[is="details-mega"][open]').forEach((candidate) => {
        if (candidate === this.menu) return;

        candidate.open = false;
      });
    }

    syncAria() {
      if (!this.summary) return;
      this.summary.setAttribute('aria-expanded', this.menu.hasAttribute('open') ? 'true' : 'false');
    }
  }

  class KozbinoMobileMenu extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.drawer = this.closest('menu-drawer');
      this.panels = Array.from(this.querySelectorAll('[data-menu-panel]'));
      this.rootPanelId = this.dataset.menuRoot;
      this.handleClick = this.handleClick.bind(this);
      this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
      this.handleDrawerHide = this.handleDrawerHide.bind(this);

      this.addEventListener('click', this.handleClick);
      document.addEventListener('menu-drawer:open', this.handleDrawerOpen);
      this.drawer?.addEventListener('drawer:handleAfterHide', this.handleDrawerHide);
      this.showPanel(this.rootPanelId, 'reset', false);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('menu-drawer:open', this.handleDrawerOpen);
      this.drawer?.removeEventListener('drawer:handleAfterHide', this.handleDrawerHide);
      this.initialized = false;
    }

    handleClick(event) {
      const openButton = event.target.closest('[data-menu-open]');
      if (openButton && this.contains(openButton)) {
        event.preventDefault();
        this.showPanel(openButton.dataset.menuOpen, 'forward');
        return;
      }

      const backButton = event.target.closest('[data-menu-back]');
      if (backButton && this.contains(backButton)) {
        event.preventDefault();
        this.showPanel(backButton.dataset.menuBack, 'back');
      }
    }

    handleDrawerOpen() {
      this.showPanel(this.rootPanelId, 'reset', false);
    }

    handleDrawerHide(event) {
      if (event.target === this.drawer) {
        this.showPanel(this.rootPanelId, 'reset', false);
      }
    }

    showPanel(panelId, direction, shouldFocus = true) {
      const nextPanel = this.panels.find((panel) => panel.dataset.menuPanel === panelId);
      if (!nextPanel) return;

      const currentPanel = this.panels.find((panel) => panel.classList.contains('is-active'));

      this.panels.forEach((panel) => {
        panel.classList.remove('is-active', 'is-before', 'is-after');
        panel.setAttribute('aria-hidden', 'true');
        panel.setAttribute('inert', '');
      });

      if (currentPanel && currentPanel !== nextPanel && direction !== 'reset') {
        currentPanel.classList.add(direction === 'back' ? 'is-after' : 'is-before');
      }

      nextPanel.classList.add('is-active');
      nextPanel.setAttribute('aria-hidden', 'false');
      nextPanel.removeAttribute('inert');

      this.querySelectorAll('[data-menu-open]').forEach((button) => {
        button.setAttribute('aria-expanded', button.dataset.menuOpen === panelId ? 'true' : 'false');
      });

      if (!shouldFocus) return;

      const title = nextPanel.querySelector('[data-menu-title]');
      if (!title) return;

      const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 230;
      window.setTimeout(() => {
        if (nextPanel.classList.contains('is-active')) {
          title.focus({ preventScroll: true });
        }
      }, delay);
    }
  }

  const initializeMegaMenus = (scope = document) => {
    scope.querySelectorAll?.('[data-kozbino-mega-menu]').forEach((menu) => {
      if (menu.dataset.kozbinoMegaInitialized === 'true') return;
      menu.dataset.kozbinoMegaInitialized = 'true';
      new KozbinoMegaMenuController(menu);
    });
  };

  if (!customElements.get('kozbino-mobile-menu')) {
    customElements.define('kozbino-mobile-menu', KozbinoMobileMenu);
  }

  document.addEventListener('DOMContentLoaded', () => initializeMegaMenus());
  document.addEventListener('shopify:section:load', (event) => initializeMegaMenus(event.target));
})();
